import { put, select, takeEvery } from 'redux-saga/effects';

import * as creditProfileActions from 'app-components/flux/credit-profile/actions';
import { getCreditProfile } from 'app-components/flux/credit-profile/selectors';
import * as creditReportActions from 'app-components/flux/credit-report/actions';
import { getCreditReport } from 'app-components/flux/credit-report/selectors';
import { rootUiActions } from 'app-components/flux/root-ui';

import {
  CREDIT_SCORE_REGISTRATION_FORM_DIALOG_ID,
  CREDIT_SCORE_VERIFICATION_DIALOG_ID,
  CREDIT_SCORE_VERIFICATION_EVENTS_DIALOG_ID,
  CREDIT_SCORE_VERIFICATION_LOADER_DIALOG_ID,
  triggerCreditScoreVerificationEventsDialog,
  triggerCreditScoreVerificationLoader,
  triggerCreditScoreVerificationSentDialog,
} from 'components/Dialogs/CreditScore/actions';
import { CREDIT_SCORE_DIALOG_EVENTS } from 'components/Dialogs/CreditScore/constants';

import { CreditScoreStatuses } from './types';

function* handleCreditProfileStatusChange() {
  // @ts-expect-error FIXME TS7057
  const creditProfileData = yield select(getCreditProfile);
  if (creditProfileData?.status === CreditScoreStatuses.AUTHENTICATION_INITIATED) {
    yield put(triggerCreditScoreVerificationSentDialog(true, creditProfileData, creditProfileData?.creditProfile?.ssn));
    yield put(
      creditProfileActions.pollRegisterCreditProfile({
        creditProfileRegistrationId: creditProfileData?.id,
        ssn: creditProfileData?.creditProfile?.ssn,
      }),
    );
  } else if (creditProfileData?.status === CreditScoreStatuses.REGISTRATION_COMPLETED) {
    yield put(rootUiActions.removeDialog(CREDIT_SCORE_VERIFICATION_DIALOG_ID));
    yield put(triggerCreditScoreVerificationEventsDialog(CREDIT_SCORE_DIALOG_EVENTS.verifying, true));
    yield put(
      creditReportActions.refreshCreditReport({
        creditProfileRegistrationId: creditProfileData?.id,
        ssn: creditProfileData?.creditProfile?.ssn,
      }),
    );
  } else if (creditProfileData?.status === CreditScoreStatuses.AUTHENTICATION_COMPLETED) {
    yield put(rootUiActions.removeDialog(CREDIT_SCORE_VERIFICATION_EVENTS_DIALOG_ID));
    yield put(
      creditProfileActions.registerCreditProfile({
        creditProfileRegistrationId: creditProfileData?.id,
        ssn: creditProfileData?.creditProfile?.ssn,
      }),
    );
  } else if (creditProfileData?.status === CreditScoreStatuses.AUTHENTICATION_FAILED) {
    yield put(rootUiActions.removeDialog(CREDIT_SCORE_VERIFICATION_EVENTS_DIALOG_ID));
    yield put(rootUiActions.removeDialog(CREDIT_SCORE_VERIFICATION_DIALOG_ID));
    yield put(triggerCreditScoreVerificationEventsDialog(CREDIT_SCORE_DIALOG_EVENTS.verificationFailed, false));
  } else if (creditProfileData?.status === CreditScoreStatuses.REGISTRATION_FAILED) {
    yield put(triggerCreditScoreVerificationEventsDialog(CREDIT_SCORE_DIALOG_EVENTS.registrationFailed, false));
  }
}

export function* creditProfileStatusWatcher() {
  yield takeEvery(
    [
      creditProfileActions.createCreditProfileSuccess,
      creditProfileActions.pollRegisterCreditProfileSuccess,
      creditProfileActions.registerCreditProfileSuccess,
    ],
    handleCreditProfileStatusChange,
  );
}

// @ts-expect-error FIXME TS7006
function* handleCreditProfileActions(action) {
  if (
    action.type === creditProfileActions.createCreditProfile.type ||
    action.type === creditProfileActions.resendVerificationRetry.type ||
    action.type === creditProfileActions.registerCreditProfile.type
  ) {
    yield put(triggerCreditScoreVerificationLoader());
  } else if (action.type === creditProfileActions.resendVerificationRetrySuccess.type) {
    yield put(rootUiActions.removeDialog(CREDIT_SCORE_VERIFICATION_DIALOG_ID));
    yield put(triggerCreditScoreVerificationEventsDialog(CREDIT_SCORE_DIALOG_EVENTS.resendLink, true));
  } else if (action.type === creditProfileActions.resendVerificationRetryFailure.type) {
    yield put(rootUiActions.removeDialog(CREDIT_SCORE_VERIFICATION_DIALOG_ID));
    yield put(triggerCreditScoreVerificationEventsDialog(CREDIT_SCORE_DIALOG_EVENTS.resendLink, false));
  } else if (action.type === creditProfileActions.verifyCreditProfileFailure.type) {
    yield put(rootUiActions.removeDialog(CREDIT_SCORE_VERIFICATION_DIALOG_ID));
    yield put(triggerCreditScoreVerificationEventsDialog(CREDIT_SCORE_DIALOG_EVENTS.verificationFailed, false));
  } else if (action.type === creditProfileActions.registerCreditProfileSuccess.type) {
    yield put(rootUiActions.removeDialog(CREDIT_SCORE_VERIFICATION_LOADER_DIALOG_ID));
  } else if (action.type === creditProfileActions.registerCreditProfileFailure.type) {
    yield put(rootUiActions.removeDialog(CREDIT_SCORE_VERIFICATION_LOADER_DIALOG_ID));
    yield put(rootUiActions.removeDialog(CREDIT_SCORE_VERIFICATION_DIALOG_ID));
    yield put(triggerCreditScoreVerificationEventsDialog(CREDIT_SCORE_DIALOG_EVENTS.registrationFailed, false));
  } else if (action.type === creditProfileActions.createCreditProfileFailure.type) {
    yield put(rootUiActions.removeDialog(CREDIT_SCORE_VERIFICATION_DIALOG_ID));
    yield put(triggerCreditScoreVerificationSentDialog(false, {}, ''));
  } else if (action.type === creditReportActions.refreshCreditReportSuccess.type) {
    yield put(rootUiActions.removeDialog(CREDIT_SCORE_VERIFICATION_EVENTS_DIALOG_ID));
    // @ts-expect-error FIXME TS7057
    const creditReportData = yield select(getCreditReport);
    if (creditReportData?.refreshStatus?.status === CreditScoreStatuses.CREDIT_REPORT_RECEIVED) {
      yield put(rootUiActions.removeDialog(CREDIT_SCORE_REGISTRATION_FORM_DIALOG_ID));
    }
  } else if (action.type === creditReportActions.getRefreshedCreditReportFailure.type) {
    yield put(triggerCreditScoreVerificationEventsDialog(CREDIT_SCORE_DIALOG_EVENTS.refreshFailed, false));
  }
}

export function* createProfileActionWatcher() {
  yield takeEvery(
    [
      creditProfileActions.createCreditProfile,
      creditProfileActions.resendVerificationRetry,
      creditProfileActions.registerCreditProfile,
      creditProfileActions.resendVerificationRetrySuccess,
      creditProfileActions.resendVerificationRetryFailure,
      creditProfileActions.verifyCreditProfileFailure,
      creditProfileActions.registerCreditProfileSuccess,
      creditProfileActions.registerCreditProfileFailure,
      creditProfileActions.createCreditProfileFailure,
      creditReportActions.refreshCreditReportSuccess,
      creditReportActions.getRefreshedCreditReportFailure,
    ],
    handleCreditProfileActions,
  );
}

export default [creditProfileStatusWatcher, createProfileActionWatcher];
